export default __webpack_public_path__ + "static/media/campaign-placeholder.99328c17.svg";